<template>
    <div>
        <nav aria-label="breadcrumb">

            <ol class="breadcrumb">
                <li v-for="(crumb) in crumbs" class="breadcrumb-item" :class="isCurrentRoute(crumb) ? 'active' : ''">
                    <a v-if="crumb.name == 'dashboard'" href="/matrices/#/dashboard">Dashboard</a>
                    <router-link v-else :to="{ name: crumb.name }">{{ crumb.text }}</router-link>
                </li>
<!--                TODO: Implement router guards-->
<!--                TODO: Handle data loss on navigate away-->
            </ol>
        </nav>
    </div>
</template>

<script>
export default {
    name: 'Breadcrumb',
    computed: {
        crumbs() {
            const vm = this;
            let items = [];
            vm.$router.options.routes.forEach((route) => {
                items.push({
                    'text': route.meta.label,
                    'name': route.name,
                    'path': route.path
                })
            })
            return items;
        },
    },
    methods: {
        isCurrentRoute(route) {
            return route.path === this.$route.path;
        }
    }
};
</script>
